import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterConsultaEscolaridade = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/presenca/${numeroFamiliar}/escolaridade`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
